import { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';

import * as actions from './store/actions';
import DataTable from '../core/components/datatable/DataTable';
import useComponentDidMount from '../core/hooks/useComponentDidMount';

// interface ServiceCardsProps {
//   getClientServiceCards?(...args: unknown[]): unknown
//   serviceCards?: unknown[]
//   clientId?: string
// }

const ServiceCards = props => {
  const {
    getClientServiceCards,
    serviceCards,
    clientId,
  } = props;

  const timeCell = (row, cell) => (moment(row[cell]).format('DD.MM.YYYY HH:mm'));
  const servicesCell = (row, cell) => {
    const services = row[cell];
    if (services) {
      return services.map(s => `${ s.name }, ${ s.limit }, ${ s.exist }`).join(';');
    }
    return '';
  };

  const columns = [
    { name: 'dateFrom', title: 'Дата начала', width: 150, getCellValue: timeCell },
    { name: 'dateTo', title: 'Дата окончания', width: 150, getCellValue: timeCell },
    { name: 'company', title: 'Компания', width: 150 },
    { name: 'brand', title: 'Марка', width: 150 },
    { name: 'model', title: 'Модель', width: 150 },
    { name: 'regNo', title: 'Номер', width: 150 },
    { name: 'vin', title: 'VIN', width: 150 },
    { name: 'policyNo', title: 'Номер полиса', width: 150 },
    { name: 'policyType', title: 'Тип полиса', width: 150 },
    { name: 'description', title: 'Описание', width: 250 },
    { name: 'services', title: 'Услуги', width: 1000, getCellValue: servicesCell },
  ];

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await getClientServiceCards(clientId);
    setLoading(false);
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <Col md={ 12 }>
      <Row>
        <Col md={ 12 }>
          <h4 className='mb-4'>Сервисные карты</h4>
          <DataTable
            loading={ loading }
            data={ serviceCards }
            columns={ columns }
            columnsResizingMode='nextColumn'
            localSorting
            localPaging
            hideToolbar
          />
        </Col>
      </Row>
    </Col>
  );
};

const mapStateToProps = state => ({
  serviceCards: state.clients.serviceCards,
});

const mapDispatchToProps = {
  getClientServiceCards: actions.getClientServiceCards,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceCards);
